import { AxiosError } from 'axios'

export interface AdminPortalError {
  description: string
  details: string[]
  correlation_id: string
}

export class AdminPortalAPIError extends AxiosError {
  // Admin Portal error specific attributes
  description: string
  details: string[]
  correlation_id: string

  constructor(err: AxiosError) {
    const rawData = err.response?.data
    let errorData: AdminPortalError | undefined

    // Handle ArrayBuffer error responses (when responseType is 'arraybuffer' and the request is not successful)
    // When the response type is arraybuffer but the request failed, error responses also come as ArrayBuffers
    // but they contain JSON that needs to be parsed
    if (rawData instanceof ArrayBuffer && err.status && err.status >= 400) {
      try {
        // Convert ArrayBuffer to string and parse as JSON
        const decoder = new TextDecoder('utf-8')
        const jsonString = decoder.decode(rawData)
        errorData = JSON.parse(jsonString) as AdminPortalError
      } catch {
        // If parsing fails, treat as unexpected error
        errorData = undefined
      }
    } else {
      errorData = rawData as AdminPortalError
    }

    const description = errorData?.description
    const details = errorData?.details ?? []
    const correlationId = errorData?.correlation_id ?? ''

    // No description means the error is not an AdminPortalError
    if (!description) {
      super('Unexpected error', err.code, err.config, err.request, err.response)
      this.description = ''
      this.details = []
      this.correlation_id = ''

      return
    }

    // The error message will be equal to the error description unless a single detail was sent.
    // If so, the detail will be used as the error message.
    const errMsg = details.length == 1 ? details[0] : description

    super(errMsg, err.code, err.config, err.request, err.response)
    this.description = description
    this.details = details
    this.correlation_id = correlationId
  }
}
